import transform from 'geojson-transformer';
import * as geolib from 'geolib';
import {findListInfo, IRegion} from '../api/operation/region';
import ParkPointLoader from '../classes/loaders/ParkPointLoader';
import RegionsLoader from '../classes/loaders/RegionsLoader';
import mapStore from '../storeInstances/mapStore';
import HeatMapLoader from '../classes/loaders/HeatMapLoader';


const regionsLoader = new RegionsLoader();
const parkPointLoader = new ParkPointLoader();
const heatMapLoader = new HeatMapLoader();

export default class RegionInfoStore {
    public regions: IRegion[] = [];
    public selectedRegion?: IRegion = undefined;
    public regionInfo?: IRegion = undefined;
    public editing: boolean = false;

    constructor() {
        regionsLoader.on('updated', () => {
            this.regions = regionsLoader.regions;
        });
    }

    public async regionSelected(id: string) {
        if (!this.regions.length || !id) {
            return;
        }
        this.editing = false;
        regionsLoader.cancelEditing();

        const region = this.regions.find(item => item._id === id);
        this.selectedRegion = region;
        if(this.selectedRegion){
            const { data } = await findListInfo(this.selectedRegion._id);
            this.regionInfo = data || undefined;
            if(this.regionInfo && region){
                this.selectedRegion = this.regionInfo;
                this.selectedRegion._id = region._id;
                console.log(this.selectedRegion);
            }
        }
        const { minLng, minLat, maxLng, maxLat } = geolib.getBounds(transform(region!.path, 'gcj02', 'wgs84').coordinates[0].map(coordinate => {
            return {
                longitude: coordinate[0],
                latitude: coordinate[1],
            };
        }));
        mapStore.fitToBounds([[minLng, minLat], [maxLng, maxLat]]);
        parkPointLoader.fetchByRegion(id);
        heatMapLoader.jumpRegion(id);
        localStorage.setItem('gide-region', region!._id);
    }

    public toggleEditing() {
        this.editing = !this.editing;
        if (this.editing && this.selectedRegion) {
            regionsLoader.startEditing(this.selectedRegion);
        } else {
            regionsLoader.finishEditing();
        }
    }

    public cancelEditing() {
        this.editing = false;
        regionsLoader.cancelEditing();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/stores/RegionInfoStore.ts